/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { PayoutAccountsWithOwnersResponse } from '../../models/payout-accounts-with-owners-response';

export interface BookingControllerGetPayoutAccountsAll$Params {
  limit: number;
  skip: number;
}

export function bookingControllerGetPayoutAccountsAll(http: HttpClient, rootUrl: string, params: BookingControllerGetPayoutAccountsAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountsWithOwnersResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerGetPayoutAccountsAll.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: PayoutAccountsWithOwnersResponse;
      }>;
    })
  );
}

bookingControllerGetPayoutAccountsAll.PATH = '/booking/wallet/payout_accounts/all';
